var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ranking-empty-wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":require(`@/assets/images/activities/ranking/no-ranking.png`)}}),_vm._v(" "),_c('p',{staticClass:"empty-tips"},[_vm._v(_vm._s(_vm.$t('ranking.list_reminder')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }